import * as React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import style from './style';

const CheckBox = (props) => {
  const [checked, setChecked] = React.useState(false);

  console.log(":::: ", props);
  const handleChange = () => {
    setChecked(!checked);
    props.checkedTnC(!checked);
  };
  const classes = style();
  return (
    <FormControl className={classes.formControl} style={{ marginBottom: "20px" }}>
      <FormControlLabel control={
        <Checkbox
          value={checked}
          className={`${classes.inputWrapper}`}
          onChange={handleChange}
          style={{ marginRight: 20 }}
        />}
        label={props.label} />
    </FormControl>
  );
};

// const Checkbox = ({ label, value, onChange }) => {
//   return (
//     <label>
//       <input type="checkbox" checked={value} onChange={onChange} />
//       {label}
//     </label>
//   );
// };

export default CheckBox;